<!-- `name` is also an input of ngModel, which types it as a plain string, hence the assertion -->
<tumaet-ui-input-number
    [ngModel]="value()"
    (ngModelChange)="onValueChange($event)"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="isDisabled()"
    [min]="min()"
    [max]="max()"
    [step]="step()"
    [snapToStep]="snapToStep()"
    [showButtons]="showButtons()"
    [fluid]="fluid()"
    [invalid]="invalid()"
    [placeholder]="placeholder()"
    [inputId]="inputId()"
    [name]="name()!"
    [ariaLabel]="ariaLabel()"
    [ariaLabelledBy]="ariaLabelledBy()"
    [ariaDescribedBy]="ariaDescribedBy()"
    [maxFractionDigits]="maxFractionDigits"
    [acceptedDecimalSeparators]="acceptedDecimalSeparators"
    [useGrouping]="false"
    locale="en-US"
    (focusout)="onFocusOut()"
/>
